import { render } from "./Analyze.vue?vue&type=template&id=4abce684&scoped=true"
import script from "./Analyze.vue?vue&type=script&lang=js"
export * from "./Analyze.vue?vue&type=script&lang=js"

import "./Analyze.vue?vue&type=style&index=0&id=4abce684&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abce684"]])

export default __exports__